import React, { useState } from 'react'
import * as Yup from 'yup'
import { Formik, ErrorMessage } from 'formik'
import styled from '@emotion/styled'
import { api } from '../../Controllers/api'
import { useDispatch } from 'react-redux'
import { getActiveNow } from '../../ActiveNow/Store/actions'

const EmailInput = styled.input`
  color: #3e3f42;
  border: #e2e5ed solid 1px;
  border-radius: 4px;
  width: 87%;
  height: 18px;
  padding: 10px 15px;
  &:focus {
    border: ${props => (props.fieldError ? '#F0535D 1px solid' : '#289C91 1px solid')};
    border-radius: 4px;
    outline: none;
  }
`

const InputContainer = styled.div`
  position: relative;
  height: 100px;
  margin-bottom: ${({ error }) => (error ? '20px' : undefined)};
`

const FormLabel = styled.div`
  p {
    color: #3e3f42;
    font-size: 16px;
    font-weight: 500;
  }
`

const FormErrorMessage = styled.div`
  color: #e6492d;
  font-size: 0.75rem;
  width: 81%;
  background-color: #fce4e5;
  border-radius: 4px;
  height: 14px;
  padding: 7px 25px;
  margin-top: 6px;
  bottom: 0;
`

const AddTruck = props => {
  const [step, setStep] = useState(0)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const cancelButton = (
    <div style={{ width: '48%' }}>
      <div
        style={{
          width: '100%',
          height: '40px',
          background: '#fff',
          boxShadow: '0px 1px 3px #00000029',
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onClick={() => {
          if (step === 0) {
            props.setAddTruck(false)
          } else {
            setStep(0)
          }
        }}
      >
        <span style={{ color: '#1565D8' }}>{step === 0 ? 'Cancel' : 'Back'}</span>
      </div>
    </div>
  )

  const handleNextButton = values => {
    if (step === 0 && values.licencePlate === '') {
      return
    }
    if (step === 0 && values.licencePlate !== '') {
      setStep(1)
    } else {
      handleSubmitTruck(values)
    }
  }

  const handleSubmitTruck = values => {
    setLoading(true)
    const body = {
      licencePlate: values.licencePlate.toUpperCase().trim(),
      phoneNumber: values.phoneNumber,
      truckId: values.truckId.toUpperCase().trim(),
      haulId: values.haul.haulId,
      material: values.haul.material
    }

    api
      .post('haullog/adddriverlessload', body)
      .then(({ data }) => {
        console.log(data)
        setLoading(false)
        dispatch(getActiveNow())
        props.setAddTruck(false)
      })
      .catch(err => {
        setLoading(false)
        alert('An error has occured.')
        console.log(err)
      })
  }

  return (
    <div style={{ margin: '0 20px' }}>
      <Formik
        initialValues={{
          licencePlate: '',
          phoneNumber: '',
          truckId: '',
          haul: props.foremanHaul ? props.foremanHaul : ''
        }}
        validationSchema={AddTruckSchema}
        onSubmit={values => {
          if (step === 0) {
            setStep(1)
          } else {
            handleSubmitTruck(values)
            console.log(values)
          }
        }}
        render={({
          values,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
          errors,
          handleChange,
          touched
        }) => (
          <form onSubmit={handleSubmit}>
            <div style={step === 0 ? undefined : { display: 'none' }}>
              <InputContainer error={errors.licencePlate ? true : false}>
                <FormLabel>
                  <p>Licence Plate</p>
                  <EmailInput
                    name="licencePlate"
                    label="Licence Plate"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.licencePlate.toUpperCase()}
                    fieldError={errors.licencePlate && touched.licencePlate ? true : false}
                    maxLength={10}
                    autoCapitalize="characters"
                  />
                </FormLabel>

                <ErrorMessage
                  name="licencePlate"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
              <InputContainer>
                <FormLabel>
                  <p>Phone</p>
                  <EmailInput
                    name="phoneNumber"
                    label="phoneNumber"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phoneNumber}
                    fieldError={errors.phoneNumber && touched.phoneNumber ? true : false}
                    maxLength={10}
                    type="tel"
                  />
                </FormLabel>

                <ErrorMessage
                  name="phoneNumber"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
              <InputContainer>
                <FormLabel>
                  <p>Unit Number</p>
                  <EmailInput
                    name="truckId"
                    label="truckId"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.truckId}
                    fieldError={errors.truckId && touched.truckId ? true : false}
                    maxLength={10}
                    autoCapitalize="characters"
                  />
                </FormLabel>

                <ErrorMessage
                  name="truckId"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
            </div>
            <div style={step === 1 ? undefined : { display: 'none' }}>
              <InputContainer>
                <FormLabel>
                  <p>Haul</p>
                  <EmailInput
                    name="haul"
                    label="haul"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.haul.haulId}
                    fieldError={errors.haul && touched.haul ? true : false}
                    maxLength={10}
                    disabled={props.foremanHaul}
                  />
                </FormLabel>

                <ErrorMessage
                  name="phoneNumber"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
              <InputContainer>
                <FormLabel>
                  <p>Pick Up</p>
                  <EmailInput
                    name="phoneNumber"
                    label="phoneNumber"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={props.foremanHaul ? props.foremanHaul.pickUpSite.siteName : ''}
                    fieldError={errors.phoneNumber && touched.phoneNumber ? true : false}
                    maxLength={10}
                    disabled
                  />
                </FormLabel>

                <ErrorMessage
                  name="phoneNumber"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
              <InputContainer>
                <FormLabel>
                  <p>Drop Off</p>
                  <EmailInput
                    name="phoneNumber"
                    label="phoneNumber"
                    className="loginInputBox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={props.foremanHaul ? props.foremanHaul.dropOffSite.siteName : ''}
                    fieldError={errors.phoneNumber && touched.phoneNumber ? true : false}
                    maxLength={10}
                    disabled
                  />
                </FormLabel>

                <ErrorMessage
                  name="phoneNumber"
                  render={msg => <FormErrorMessage>{msg}</FormErrorMessage>}
                />
              </InputContainer>
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                zIndex: 1
              }}
            >
              <div
                style={{
                  margin: '0 8px 16px 8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                {cancelButton}
                <div style={{ width: '48%' }}>
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: '100%',
                      height: '40px',
                      background:
                        step === 0 && values.licencePlate.length > 0
                          ? 'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box'
                          : '#FFF',
                      boxShadow: '0px 1px 3px #00000029',
                      borderRadius: '4px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: 'none',
                      fontSize: '1rem',
                      color: step === 0 && values.licencePlate.length > 0 ? '#fff' : '#1565D8'
                      // pointerEvents: isValid ? 'auto' : 'none'
                    }}
                    onClick={() => handleNextButton(values)}
                  >
                    {step === 0 ? ' Next' : 'Finish'}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      />
    </div>
  )
}

export default AddTruck

const AddTruckSchema = Yup.object()
  .shape({
    licencePlate: Yup.string().required('You must enter a license plate'),
    phoneNumber: Yup.string()
      .length(10, 'Phone number must be 10 digits')
      .matches(/^[0-9]{0,}$/, 'No spaces or special characters allowed'),
    truckId: Yup.string()
  })
  .atLeastOneOf(['signOnTime', 'signOffTime'])
